import { PropsWithChildren } from 'react';
import { RadioGroup as RadixRadioGroup } from 'radix-ui';
import { twMerge } from 'tailwind-merge';

export interface RadioGroupProps extends RadixRadioGroup.RadioGroupProps {}

export const RadioGroup = ({
  children,
  className,
  ...otherProps
}: PropsWithChildren<RadioGroupProps>) => {
  return (
    <RadixRadioGroup.Root className={twMerge('flex flex-col gap-2.5', className)} {...otherProps}>
      {children}
    </RadixRadioGroup.Root>
  );
};
